export const BIRDVIEW_AGING_CHART_PROPS = {
  barCategoryGap: '24%',
  margin: { bottom: 0, left: 0, right: 0, top: 8 },
}

export const BIRDVIEW_AGING_CHART_BAR_PROPS = { radius: [6, 6, 0, 0] }
